import { useEffect, useLayoutEffect, useState } from "react";
import { Button } from "./ui/button";
import { BookingVenueStep } from "./BookingVenueStep";
import { BookingTimeStep } from "./BookingTimeStep";
import { api, errorMessage } from "../lib/api";

export const BookingWizard = ({ initialVenueId, prefill, callNote, callId, csrfToken, onBack, onBooked, onAgenda }) => {
  const [venue, setVenue] = useState(null);
  const [step, setStep] = useState(initialVenueId ? 2 : 1);
  const [slot, setSlot] = useState(null);
  const [summary, setSummary] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (initialVenueId) api.get(`/venues/${initialVenueId}`)
      .then(({ data }) => { setVenue(data); setContactName(data.contact_name || "");
        setContactPhone(data.contact_phone || data.phone || data.contacts?.find((item) => item.type === "phone")?.value || "");
      }).catch((e) => setError(errorMessage(e)));
  }, [initialVenueId]);
  useLayoutEffect(() => {
    const sheet = document.querySelector('[data-testid="booking-sheet"], [data-testid="venue-sheet"]');
    if (sheet) sheet.scrollTop = 0;
  }, [step, venue?.id]);
  const chooseVenue = (item) => { setVenue(item); setContactName(item.contact_name || "");
    setContactPhone(item.contact_phone || item.phone || item.contacts?.find((contact) => contact.type === "phone")?.value || "");
    setSlot(null); setStep(2); setError(""); };
  const chooseSlot = (item) => { setSlot(item); setStep(3); setError(""); };
  const goBack = () => { if (step === 3) setStep(2); else if (step === 2 && !initialVenueId) setStep(1); else onBack(); setError(""); };
  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try {
      const { data } = await api.post(`/venues/${venue.id}/appointments`, {
        presenter_id: slot.presenter_id, participant_ids: slot.participant_ids,
        date: slot.date, time: slot.time,
        duration_minutes: 60, summary: summary.trim(),
        contact_name: contactName.trim(), contact_phone: contactPhone.trim(),
        ...(callNote ? { call_note: callNote } : {}),
        ...(callId ? { call_id: callId } : {}),
      }, { headers: { "X-CSRF-Token": csrfToken } });
      onBooked(data);
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <div className="booking-wizard" data-testid="booking-wizard">
    <button type="button" className="sheet-back" onClick={goBack} data-testid="booking-back-button">‹ {step === 1 ? "Chiudi" : "Indietro"}</button>
    <h2 className="sheet-title" data-testid="booking-title">{["", "Quale locale?", "Quando?", "Conferma"][step]}</h2>
    <div className="booking-progress" role="progressbar" aria-label="Fissa incontro" aria-valuenow={step} aria-valuemin="1" aria-valuemax="3" data-testid="booking-progress">{[1, 2, 3].map((number) => <span key={number} className={number <= step ? "active" : ""} />)}</div>
    {step === 1 && <BookingVenueStep onChoose={chooseVenue} />}
    {step === 2 && venue && <BookingTimeStep key={venue.id} venue={venue} prefill={prefill} onChoose={chooseSlot} onAgenda={onAgenda} />}
    {step === 3 && venue && slot && <form className="booking-step booking-confirm" onSubmit={submit} data-testid="booking-confirm-step">
      <div className="booking-confirm-detail" data-testid="booking-confirm-detail"><strong>{venue.name}</strong><span>{slot.date} · {slot.time} · {slot.participant_names?.join(", ")}</span><small>60 minuti</small></div>
      <div className="form-field"><label htmlFor="booking-contact-name">REFERENTE DEL LOCALE</label>
        <input id="booking-contact-name" type="text" autoComplete="name" required minLength={2} maxLength={120}
          placeholder="Nome e cognome" value={contactName} onChange={(e) => setContactName(e.target.value)}
          data-testid="booking-contact-name-input" /></div>
      <div className="form-field"><label htmlFor="booking-contact-phone">CONFERMA IL NUMERO DEL REFERENTE</label>
        <input id="booking-contact-phone" type="tel" inputMode="tel" autoComplete="tel" required minLength={6} maxLength={35}
          placeholder="Numero diretto" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)}
          data-testid="booking-contact-phone-input" /></div>
      <div className="form-field"><label htmlFor="booking-summary">RIEPILOGO</label><textarea id="booking-summary" className="hud-textarea" required minLength={1} maxLength={2000} placeholder="Scrivi una riga per chi viene dopo (obbligatorio)" value={summary} onChange={(e) => setSummary(e.target.value)} data-testid="booking-summary-input" /></div>
      <Button type="submit" className="hud-button" disabled={busy || !summary.trim() || contactName.trim().length < 2 || !contactPhone.trim()} data-testid="booking-submit-button">{busy ? "Salvataggio…" : "Fissa appuntamento"}</Button>
    </form>}
    {error && <p className="form-error" role="alert" data-testid="booking-error">{error}</p>}
  </div>;
};